module.exports = new __parcel__URL__("organic.1e059985.glb").toString();